module.exports = __webpack_public_path__ + "static/media/logo_small.31cd88b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo_small.svg
// module id = 1349
// module chunks = 0